import React, { ChangeEvent, useEffect, useState } from "react";
import { QuestionInput } from "../../../../../__generated__/gql-types/globalTypes";
import { FileImageCoverProps } from "../../utils";
import { DeleteOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";
import { Field } from "formik";
import styles from "../../quizzForm.module.css";
import { UploadImageFile } from "../../../../UploadFile";

interface AIResponseProps {
  question: QuestionInput;
  handleRemoveAnswer: () => void;
  handleAddAnswer: () => Promise<void>;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    index?: number
  ) => void;
  urlImageAnswers: string[];
  setUrlImageAnswers: React.Dispatch<React.SetStateAction<string[]>>;
  imageAnswers: string[];
  setimageAnswers: React.Dispatch<React.SetStateAction<string[]>>;
  handleImageAnswers: (newImage: string, indexAnswer: number) => void;
}

const AIResponse = ({
  question,
  imageAnswers,
  urlImageAnswers,
  handleAddAnswer,
  handleRemoveAnswer,
  handleChange,
  setUrlImageAnswers,
  setimageAnswers,
  handleImageAnswers,
}: AIResponseProps) => {
  const [imagesAnswer, setImagesAnswer] = useState<FileImageCoverProps[]>([]);

  const sortInfo = () => {
    if (question.answers && question.answers.length > 0) {
      question.answers.map((answer, index) => {
        if (answer.image && answer.image.length > 0) {
          setImagesAnswer([
            ...imagesAnswer,
            {
              id: answer?.image?.split(".")[0],
              ext: answer?.image?.split(".")[1],
            },
          ]);
        } else {
          setImagesAnswer([
            ...imagesAnswer,
            {
              id: "",
              ext: "",
            },
          ]);
        }
      });
    }
  };

  useEffect(() => {
    sortInfo();
  }, [question, handleAddAnswer, handleChange, handleAddAnswer]);

  return (
    <>
      {question?.answers?.map((answer, index: number) => {
        return (
          <Col key={`${index}_${new Date()}`}>
            <Row style={{ marginLeft: 20, marginTop: 10 }}>
              <label htmlFor="steps">Respuesta Modelo</label>
            </Row>
            <Row style={{ marginLeft: 20 }}>
              <Col span={22}>
                <Field
                  id="answer"
                  name="answer"
                  type="text"
                  defaultValue={answer?.answer ?? ""}
                  onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    handleChange(event, index);
                  }}
                  className={styles.formFieldSelect}
                ></Field>
              </Col>
            </Row>
          </Col>
        );
      })}
    </>
  );
};

export default AIResponse;
